(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(69290);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21194);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);




var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var SeoGlobalNavbar = function(param) {
    var enrollmentURL = param.enrollmentURL, _internalLinkingMenuContent = param.internalLinkingMenuContent, internalLinkingMenuContent = _internalLinkingMenuContent === void 0 ? undefined : _internalLinkingMenuContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        baseURL: NEXT_PUBLIC_APP_URL,
        findJobURL: "/app/vhp/vertical-triage?memberType=sitter",
        logAnalyticsEvent: _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .logOrEnqueueEvent */ .sw,
        joinNowURL: enrollmentURL,
        internalLinkingMenu: {
            internalLinkingMenu: true,
            internalLinkingMenuContent: internalLinkingMenuContent
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoGlobalNavbar);


/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ AmplitudeEvent; },
/* harmony export */   "UP": function() { return /* binding */ setPagePropertiesFromData; },
/* harmony export */   "rG": function() { return /* binding */ trackAmplitudeEvent; },
/* harmony export */   "sw": function() { return /* binding */ logOrEnqueueEvent; },
/* harmony export */   "xF": function() { return /* binding */ setDeviceDataFromHeaders; }
/* harmony export */ });
/* unused harmony exports WebPlatform, AMPLITUDE_DATE_FORMAT, AMPLITUDE_TIME_FORMAT, AnalyticsHelper, enqueEvent */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _care_amplitude__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91649);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);








var WebPlatform;
(function(WebPlatform) {
    WebPlatform["MW"] = "Mobile Web";
    WebPlatform["DT"] = "Desktop Web";
})(WebPlatform || (WebPlatform = {}));
var AmplitudeEvent;
(function(AmplitudeEvent) {
    AmplitudeEvent["applySegmentationFilter"] = "Apply Segmentation Filter";
    AmplitudeEvent["clickOnSegmentationFilter"] = "Click on Segmentation Filter";
    AmplitudeEvent["ctaInteracted"] = "CTA Interacted";
    AmplitudeEvent["providerProfileViewed"] = "Provider Profile Viewed";
    AmplitudeEvent["monetateAssetClicked"] = "Monetate Asset Clicked";
    AmplitudeEvent["seoPageViewed"] = "SEO Page Viewed";
    AmplitudeEvent["viatorCardClick"] = "SEO - Viator card clicked";
    AmplitudeEvent["testExposure"] = "Test Exposure";
    AmplitudeEvent["jobViewed"] = "Job Viewed";
    AmplitudeEvent["seoFeatureInteracted"] = "SEO Feature Interacted";
    AmplitudeEvent["errorViewed"] = "Error Viewed";
})(AmplitudeEvent || (AmplitudeEvent = {}));
var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var AMPLITUDE_DATE_FORMAT = "MMDDYYYY";
var AMPLITUDE_TIME_FORMAT = "hh:mm A";
var initialized = false;
var AnalyticsHelper = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsHelper() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AnalyticsHelper);
        this.amplitudeEventsQueue = [];
        this.setHeaderData = function(data) {
            _this.headerData = data;
        };
        this.setPageProperties = function(properties) {
            _this.pageProperties = properties;
        };
        this.getHeaderData = function() {
            return _this.headerData;
        };
        this.setEventInQueue = function(event) {
            // @ts-ignore FIX: event is of never type
            _this.amplitudeEventsQueue.push(event);
        };
        this.getEventFromQueue = function() {
            return _this.amplitudeEventsQueue.shift();
        };
        this.getCommonData = function() {
            var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
            var ref = _this.headerData || {}, deviceOs = ref.device_os, isMobile = ref.is_mobile, mobileBrowser = ref.mobile_browser, mobileBrowserVersion = ref.mobile_browser_version;
            var ref1 = _this.pageProperties || {}, seoPageId = ref1.seo_page_id, screenName = ref1.screen_name, screenTemplate = ref1.screen_template, ServiceIdForMember = ref1.service_id_for_member, slots = ref1.slots;
            var czenVisitorId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_VISITOR_COOKIE_KEY */ .iN);
            var czenSessionId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_SESSION_COOKIE_KEY */ .Ih);
            var screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
            var viewportResolution = "".concat(window.innerWidth, " x ").concat(window.innerHeight);
            var visitorId = czenVisitorId || "VisitorIdNotFound";
            var CZENSessionId = czenSessionId || "SessionIdNotFound";
            var deviceModel = (deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ").length) > 1 ? deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ")[0] : deviceOs;
            var webPlatform = isMobile === "true" ? WebPlatform.MW : WebPlatform.DT;
            var commonData = {
                czen_session_id: CZENSessionId,
                device_model: deviceModel,
                environment: publicRuntimeConfig.SENTRY_ENV,
                language: navigator.language,
                os_name: mobileBrowser,
                os_version: mobileBrowserVersion,
                referer: document.referrer,
                rendered_by: "seo-mfe",
                screen_name: screenName,
                screen_resolution: screenResolution,
                screen_template: screenTemplate,
                seo_page_id: seoPageId,
                service_id_for_member: ServiceIdForMember,
                slots: slots,
                userAgent: navigator.userAgent,
                viewport_resolution: viewportResolution,
                visitor_id: visitorId,
                web_platform: webPlatform
            };
            return commonData;
        };
        this.logEvent = function(payload) {
            try {
                if (!initialized) {
                    var careAnalyticsConfig = {
                        analyticsEnabled: publicRuntimeConfig.ANALYTICS_ENABLED === "true",
                        key: publicRuntimeConfig.AMPLITUDE_API_KEY,
                        commonData: _this.getCommonData()
                    };
                    (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .init */ .S1)(careAnalyticsConfig);
                    initialized = true;
                    // session id is available with a small delay after amplitude initialization
                    setTimeout(function() {
                        var ref;
                        var amplitudeSessionId = (ref = (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .getInstance */ .s8)()) === null || ref === void 0 ? void 0 : ref.getSessionId();
                        if (amplitudeSessionId) {
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .configureScope */ .e)(function(scope) {
                                var user = scope.getUser();
                                scope.setUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, user), {
                                    amplitudeSessionId: amplitudeSessionId
                                }));
                            });
                        }
                    });
                }
                var logEventPayload = {
                    name: payload.name,
                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload.data)
                };
                (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .Kz)(logEventPayload);
            } catch (e) {
                (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb)(e);
            }
        };
    }
    AnalyticsHelper.init = function init() {
        if (this.analytics === undefined) {
            this.analytics = new AnalyticsHelper();
        }
        return this.analytics;
    };
    return AnalyticsHelper;
}();
var enqueEvent = function(event) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setEventInQueue(event);
    return event;
};
var dequeEvent = function() {
    var analyticsInstance = AnalyticsHelper.init();
    return analyticsInstance.getEventFromQueue();
};
var logOrEnqueueEvent = function(param) {
    var name = param.name, data = param.data;
    if (!name || !data) return null;
    var analyticsInstance = AnalyticsHelper.init();
    if (analyticsInstance.getHeaderData() === undefined) {
        return enqueEvent({
            name: name,
            data: data
        });
    }
    return analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.logEvent({
        data: data,
        name: name
    });
};
var trackAmplitudeEvent = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    logOrEnqueueEvent({
        name: name,
        data: data
    });
};
var setPagePropertiesFromData = function(properties) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setPageProperties(properties);
};
var setDeviceDataFromHeaders = function(data) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setHeaderData(data);
    var eventsPresentInQueue = analyticsInstance.amplitudeEventsQueue.length;
    if (eventsPresentInQueue > 0) {
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < eventsPresentInQueue; i++){
            var ref = dequeEvent(), eventName = ref.name, eventData = ref.data;
            trackAmplitudeEvent(eventName, eventData);
        }
        return eventsPresentInQueue;
    }
    return data;
};


/***/ }),

/***/ 69290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Custom404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 12 modules
var CoreGlobalFooter = __webpack_require__(11566);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationXlargeBoat.js
var IconIllustrationXlargeBoat = __webpack_require__(12499);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/PictogramTechnicalErrorState.js
var PictogramTechnicalErrorState = __webpack_require__(67288);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useActiveTheme.js
var useActiveTheme = __webpack_require__(56721);
;// CONCATENATED MODULE: ./node_modules/@care/react-pages/dist/utils/styles.js
const styles = {
    managedContainer: {
        flexDirection: {
            xs: 'column-reverse',
            md: 'row',
        },
        marginBottom: {
            xs: '8px',
            md: '16px',
            lg: '48px',
            xl: '80px',
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: {
            xs: '8px',
            md: '16px',
            lg: '48px',
            xl: '80px',
        },
        maxWidth: '744px',
    },
    sizedImage: {
        '& img, & svg': {
            height: {
                xs: '260px',
                sm: '283px',
                md: '100%',
            },
            maxHeight: '400px',
            maxWidth: '480px',
            verticalAlign: 'middle',
            width: {
                xs: '311px',
                sm: '340px',
                md: '100%',
            },
        },
    },
    innerContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: {
            xs: '80%',
            sm: '340px',
            md: '100%',
        },
        width: '340px',
    },
    displayText: {
        py: 1,
        px: 0,
    },
    inlinePara: {
        display: 'inline',
    },
    errorTitle: {
        marginBottom: '3px',
        marginTop: {
            xs: '56px',
            md: '0',
        },
    },
    headline: {
        fontSize: {
            xs: '1.75rem',
            sm: '2.25rem',
        },
        fontWeight: 700,
        lineHeight: {
            xs: '34px',
            sm: '42px',
        },
        mb: {
            xs: 0,
            sm: 2.625,
        },
        mt: {
            xs: 3,
            md: 5.25,
        },
    },
};
/* harmony default export */ var utils_styles = (styles);
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
;// CONCATENATED MODULE: ./node_modules/@care/react-pages/dist/utils/ErrorNavigationLinks.js
/* eslint-disable no-script-url, prettier/prettier */



/** Utility component for rendering the navigation links on error pages */
const ErrorNavigationLinks = (props) => {
    const { prev, onClick, homeLinkWrapper = undefined, homeUrl = '/' } = props;
    const homeLink = (react.createElement(Link/* default */.Z, { variant: "link1", href: homeUrl }, "homepage"));
    const handleClick = (event) => {
        event.preventDefault();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    const linkProps = {
        href: prev,
        onClick: !prev && onClick ? handleClick : undefined,
    };
    return (react.createElement(react.Fragment, null,
        (prev !== null && prev !== void 0 ? prev : onClick) ? (react.createElement(react.Fragment, null,
            react.createElement(Typography/* default */.Z, { variant: "body1", color: "text.primary", sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.inlinePara }, 'Go back to the '),
            react.createElement(Link/* default */.Z, Object.assign({ variant: "link1" }, linkProps), "previous page"),
            react.createElement(Typography/* default */.Z, { variant: "body1", color: "text.primary", sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.inlinePara }, ', or return to the '))) : (react.createElement(Typography/* default */.Z, { variant: "body1", color: "text.primary", sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.inlinePara }, 'Please visit our ')),
        homeLinkWrapper ? homeLinkWrapper(homeLink) : homeLink,
        "."));
};
/* harmony default export */ var utils_ErrorNavigationLinks = (ErrorNavigationLinks);
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/react-pages/dist/Error404/Error404.js






/** Error404 is used to indicate a a broken link or missing url. */
const Error404 = (props) => {
    const { isEmbraceTheme } = (0,useActiveTheme/* default */.Z)();
    return (react.createElement(Grid/* default */.ZP, { container: true, alignItems: "center", sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.managedContainer },
        react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sm: 12, md: 6 },
            react.createElement(Grid/* default */.ZP, { container: true, sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.innerContainer },
                react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sm: 12, sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.displayText },
                    react.createElement(Typography/* default */.Z, { variant: "h1", color: "text.primary", sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.headline }, "We can't seem to find that page")),
                react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.displayText },
                    react.createElement(Typography/* default */.Z, { variant: "body1", color: "text.primary" }, "It's missing or the link is broken. Here's what usually helps:")),
                react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.displayText },
                    react.createElement(utils_ErrorNavigationLinks, Object.assign({}, props))),
                react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.displayText },
                    react.createElement(Typography/* default */.Z, { variant: "body3", color: "text.secondary" }, "Error Code: 404")))),
        react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sm: 12, md: 6, sx: utils_styles === null || utils_styles === void 0 ? void 0 : utils_styles.sizedImage }, isEmbraceTheme ? (react.createElement(PictogramTechnicalErrorState/* default */.Z, { height: 480, width: 480 })) : (react.createElement(IconIllustrationXlargeBoat/* default */.Z, null)))));
};
/* harmony default export */ var Error404_Error404 = (Error404);
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
;// CONCATENATED MODULE: ./src/components/pages/404.tsx





function Custom404() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                    enrollmentURL: "/enroll-care-seeker-p1042-q111082615.html"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                py: 3,
                px: 9,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Error404_Error404, {
                        prev: "/"
                    }),
                    ";"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/404.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,4690,6537,6506,6886,9417,5995,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);